import React from 'react';

const CircularPending = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
  >
    <circle cx="24" cy="24" r="24" fill="#FEA50A" />
    <path
      d="M24.0214 29.0373C22.9436 29.0373 22.04 29.9408 22.04 31.0186C22.04 32.0965 22.9436 33 24.0214 33C25.0597 33 26.0028 32.0965 25.9553 31.0662C26.0028 29.9328 25.1072 29.0373 24.0214 29.0373Z"
      fill="white"
    />
    <path
      d="M23.5296 14.0561C22.5865 14.3255 22 15.1815 22 16.2197C22.0476 16.8459 22.0872 17.4799 22.1347 18.106C22.2695 20.4916 22.4042 22.8297 22.5389 25.2153C22.5865 26.0237 23.2126 26.6102 24.021 26.6102C24.8294 26.6102 25.4635 25.984 25.5031 25.1677C25.5031 24.6763 25.5031 24.2246 25.5507 23.7252C25.6378 22.1956 25.7329 20.666 25.8201 19.1363C25.8677 18.1457 25.9549 17.155 26.0024 16.1643C26.0024 15.8076 25.9549 15.4906 25.8201 15.1736C25.4159 14.2859 24.4728 13.8341 23.5296 14.0561Z"
      fill="white"
    />
  </svg>
);

export default CircularPending;
